const state = {
	data: null
}
const mutations = {
	'SET_CONFIG' (state, value) {
		state.data = value
	}
}
const actions = {
	async fetch ({ commit, dispatch }) {
		await dispatch('callApi', {
			method: 'GET',
			ingoreBaseUrl: true,
			url: this._vm.CMS_BASE_URL + '/cms/configuration/globals'
		}, { root: true }).then(resp => {
			commit('SET_CONFIG', resp.data.configuration)
		}).catch(err => {
			console.error(err)
			this.commit('Toast/_addError', 'Failed fetching configuration')
		})
	},
	save ({ commit, dispatch }, payload) {
		dispatch('callApi', {
			method: 'POST',
			ingoreBaseUrl: true,
			url: this._vm.CMS_BASE_URL + '/cms/configuration',
			headers: payload.headers || {},
			data: payload.data
		}, { root: true }).then((resp) => {
			commit('SET_CONFIG', resp.data)
            if (payload && !payload.silent) {
                this.commit('Toast/_add', 'Configuration saved!')
            }
		}).catch((err) => {
			console.error(err)
			if(403 == err.response.status) {
				this.commit('Toast/_addError', 'Forbidden (#403) - You are not allowed to perform this action!')
			}else{
				this.commit('Toast/_addError', 'Failed to load email templates')
			}
		})
	}
}
const getters = {
	getConfig: (state) => {
		return state.config
	}
}
export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
